import { FC } from 'react';

import { Box } from '@qwealth/qcore';

import { StyledClientNotesHistoryNoteCard } from './NoteHistory.styled';
import { ComplianceNote } from 'data/models/Compliance';
import { formatDateInUserTimezone, LONG_MONTH_DATE_AM_PM_TIME_FORMAT } from 'data/helpers/dateTimeHelper';
import { useAppSelector } from 'data/store';
import { selectUser } from 'data/selectors/userSelectors';

interface Props {
  note: ComplianceNote;
}

const ClientNotesHistoryNoteCard: FC<Props> = ({ note }): JSX.Element => {
  const { timeZone } = useAppSelector(selectUser);
  return (
    <StyledClientNotesHistoryNoteCard>
      <Box fontWeight="bold">{note.title}</Box>
      <Box paddingLeft="large">{note.content}</Box>
      <Box fontSize="small" alignSelf="end">
        By {note.author || ''} on{' '}
        {note.contentUpdateTime ? formatDateInUserTimezone(note.contentUpdateTime, timeZone, LONG_MONTH_DATE_AM_PM_TIME_FORMAT) : ''}
      </Box>
    </StyledClientNotesHistoryNoteCard>
  );
};

export default ClientNotesHistoryNoteCard;
